<template>
  <div>
    <div class="container">
      <h1 class="pb-2 mt-4 mb-2 border-bottom">{{ $t(pageTitle) }}</h1>

      <div>
        <p>{{ $t('ご登録ありがとうございました。') }}</p>
        <p>{{ $t('ご記入頂いた内容で登録しました。') }}</p>
        <p>{{ $t('後ほど、当サイトからご登録頂いたメールアドレス宛てに、登録完了メールが届きます。') }}</p>
        <p>{{ $t('万が一、メールが届かない場合は、迷惑メールに分類されているか、メールアドレスが間違っている可能性がございます。その場合は、お手数ですがお問い合わせフォームよりお問い合わせ下さい。') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signupDone',
  data() {
    return {
      pageTitle: 'ものレボ会員登録完了',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
}
</script>
